export default __webpack_public_path__ + "static/media/invoice_template.f5ae542d.jpg";